import { render, staticRenderFns } from "./HeroBox.vue?vue&type=template&id=c65b17ca&scoped=true&"
import script from "./HeroBox.vue?vue&type=script&lang=ts&"
export * from "./HeroBox.vue?vue&type=script&lang=ts&"
import style0 from "./HeroBox.vue?vue&type=style&index=0&id=c65b17ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65b17ca",
  null
  
)

export default component.exports